export default __webpack_public_path__ + "static/media/orders.acaaff61.svg";